'use client'

export default function NotFound() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-foreground">
      <div className="text-center space-y-2">
        <p className="text-sm uppercase tracking-[0.3em] text-muted-foreground">404</p>
        <h1 className="text-2xl font-semibold">Page non trouvée</h1>
        <p className="text-muted-foreground">Le contenu recherché n’existe pas ou a été déplacé.</p>
      </div>
    </div>
  )
}
